import ShadowScroll from './ShadowScroll';

export default ShadowScroll;
